<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">{{ $t('message.Impressum.title') }}</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div class="col-md-12">
          <div class="card card-form">
            <div v-if="impressumLoading === true" class="h-100 d-flex justify-content-center align-items-center">
              <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
            </div>

            <div v-else class="card-body">
              <div class="form-section-header">{{ $t('message.Impressum.title') }}</div>

              <ckeditor
                v-if="impressumLoaded === true"
                :editor="editor" 
                v-model="editorData"
                v-validate="'required'"
                data-vv-name="editorData"
                data-vv-model="editorData"
                :config="editorConfig"
                @ready="ckeditorReady=true"></ckeditor>

              <div v-if="errors.first('editorData')" class="text-danger">Buchtitel bitte eingeben</div>
              <div class="form-buttons">
                <button type="submit" class="btn btn-warning mr-2" @click="proceedDefault">{{ $t('message.Impressum.default') }} </button>
                <button type="submit" class="btn btn-success" @click="proceed">{{ $t('message.proceed') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import {IMPRESSUM_SAVE, IMPRESSUM_LOAD, IMPRESSUM_DEFAULT} from '@/store/actions/impressum';


  import firebase from 'firebase/app';

  export default {
    name: "Impressum",
    components: {},

    data() {
      return {
        editor: ClassicEditor,
        editorData: '',
        editorConfig: {
          // The configuration of the editor.
        },

        ckeditorReady: false,
      }
    },

    methods: {
      proceed() {
        this.$validator.validate().then(result => {
          if (!result) {
            this.$swal({
              title: 'Error!',
              text: this.$t("message.Book.errors.fillRequiredFields"),
              type: 'error',
              confirmButtonText: 'OK'
            });

            this.showValidateErrors = true;
          } else {
            return this.saveRow();
          }
        });
      },

      async saveRow() {
        this.$store.dispatch(IMPRESSUM_SAVE, this.editorData)
          .then(() => {
            this.$swal({
              title: this.$t("message.success"),
              text: this.$t("message.successfullySaved"),
              type: 'success',
              confirmButtonText: 'OK'
            }).then(() => {
              this.$router.push({name: 'Impressum'});
            })
          })
          .catch(err => {
            alert('error')
            console.log(err)
          })
      },

      proceedDefault() {
        this.$swal({
          title: this.$t("message.Impressum.restoreDefault"),
          html: this.$t("message.Impressum.restoreDefaultInfo"),
          type: 'info',
          confirmButtonText: this.$t("message.Impressum.restore"),
          showCancelButton: true,
        })
            .then(value => {
              if(value.value != undefined) {
                this.$store.dispatch(IMPRESSUM_DEFAULT)
                    .then(() => {
                      console.log(this.impressum)
                      this.editorData = this.impressum;
                      this.$swal({
                        title: this.$t("message.success"),
                        text: this.$t("message.Impressum.successfullyRestored"),
                        type: 'success',
                        confirmButtonText: 'OK'
                      })
                    })
                    .catch(err => {
                      alert('error')
                      console.log(err)
                    })
              }
            });
      }
    },

    computed: {
      siteReady() {
        return this.ckeditorReady * this.impressumLoaded
      }
    },

    mounted() {
      this.$store.dispatch(IMPRESSUM_LOAD)
          .then(() => {
            this.text = this.impressum;
          })
    },

    watch: {
      siteReady: function(newValue) {
        if (newValue) {
          this.editorData = this.impressum;
        }
      }
    }
  }
</script>

<style scoped>
</style>